export default "__VITE_ASSET__mh7FY5NI__"